/**
 * Marka: yan yana duran iki adet 2'li — karo ve kupa — ve yanında "Başgan".
 *
 * 2 oyunun en güçlü kartı ve turu kesen tek şey; ilk eli de karo 2 başlatıyor.
 * Logonun onlardan kurulması tesadüf değil.
 */
export function Logo({ size = 'lg' }: { size?: 'lg' | 'sm' }) {
  return (
    <div className={`logo logo--${size}`}>
      <span className="logo__cards" aria-hidden>
        <span className="logo__card logo__card--back">
          2<i>♦</i>
        </span>
        <span className="logo__card logo__card--front">
          2<i>♥</i>
        </span>
      </span>
      <span className="logo__word">Başgan</span>
    </div>
  );
}
